import { createContext } from 'react';

export const ModalQrCodeContext = createContext();
